import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import PlbyHierarchicalPopup from "../reports/PlbyHierarchicalPopup";

export default function DailyPlRoundPlayersPopupPage() {
  const { transid } = useParams();
  const [record, setRecord] = useState(null);

  useEffect(() => {
    if (!transid) return;

    const fetchRecord = async () => {
      try {
        const response = await axiosInstance.get(
          `/master/daily-pl-by-users/round-players/${transid}`
        );
        setRecord(response.data);
      } catch (error) {
        console.error("Error fetching round players:", error);
      }
    };

    fetchRecord();
  }, [transid]);

  return <>{record && <PlbyHierarchicalPopup data={record} />}</>;
}
